import { Link, useLocation, useNavigate } from 'react-router-dom';
import Wordmark from './Wordmark';

const NAV = [
  { to: '/product', label: 'Platform' },
  { to: '/support', label: 'Support' },
  { to: '/company', label: 'Company' },
];

export default function MarketingShell({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  function goInvite() {
    if (location.pathname === '/') {
      document.getElementById('invite')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#invite');
    }
  }

  return (
    <div className="mk-shell">
      <div className="mk-announce">
        Transformax is <b>launching soon</b> — now accepting a limited number of design partners
      </div>
      <div className="mk-page">
        <header className="mk-header">
          <Link to="/"><Wordmark /></Link>
          <nav className="mk-nav-links">
            {NAV.map(item => (
              <Link
                key={item.to}
                to={item.to}
                className={location.pathname === item.to ? 'is-active' : ''}
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <div className="mk-actions">
            <button className="btn-ghost" onClick={() => navigate('/auth?mode=signin&direct=1')}>Sign in</button>
            <button className="btn-primary" onClick={goInvite}>Request an invitation</button>
          </div>
        </header>

        <main className="mk-main">{children}</main>

        <footer className="mk-footer">
          <div className="mk-footer-grid">
            <div className="mk-footer-col">
              <Wordmark className="logo-mark mk-footer-logo" />
              <p>Transformation programme management, built for governance, delivery, and finance in one platform.</p>
            </div>
            <div className="mk-footer-col">
              <h5>Product</h5>
              <Link to="/product">Platform</Link>
              <a href="/#invite">Request an invitation</a>
            </div>
            <div className="mk-footer-col">
              <h5>Company</h5>
              <Link to="/company">About</Link>
              <Link to="/company">Contact</Link>
            </div>
            <div className="mk-footer-col">
              <h5>Support</h5>
              <Link to="/support">Help centre</Link>
              <a href="mailto:support@transformax.app">Contact support</a>
            </div>
          </div>
          <div className="mk-footer-bottom">
            <span>&copy; 2026 Transformax. All rights reserved. · Private beta — invitation only</span>
            <span>transformax.app</span>
          </div>
        </footer>
      </div>
    </div>
  );
}
